module.exports = __webpack_public_path__ + "landing_static/img/header-lg-t.c12c7591.png";